import React, { Component } from 'react';
import { Theme } from '../Theme';

export interface TabsItemProps {
    label: string;
    id: string;
    onSelect: () => void;
}

export interface TabsProps {
    options: Array<TabsItemProps>,
    selectedTabsItemIndex: number,
    style?: React.CSSProperties,
}

interface State {
    selectedTabsItemIndex: number;
}

export class TabsView extends Component<TabsProps, State> {
    
    constructor(props: TabsProps) {
        super(props);
        this.state = {
            selectedTabsItemIndex: this.props.selectedTabsItemIndex,
        };
        console.log(`TABS_VIEW: constructor()`);
    }

    renderTabsItem(index: number, item: TabsItemProps) {
        const isSelected = this.state.selectedTabsItemIndex === index;
        return (
            <div key={index}
                style={isSelected ? styles.tabsItemSelected : styles.tabsItem} 
                onClick={() => {
                    this.setState({ selectedTabsItemIndex: index } );
                    item.onSelect();
                }}
            >
                {item.label}
            </div>
        );
    }

    render(): React.ReactNode {
        return (
            <div style={{ ...styles.container, ...this.props.style }}>
                {this.props.options.map((option, index) => this.renderTabsItem(index, option))}
            </div>
        );
    }
};

const styles = {
    container: { 
        flexDirection: 'row' as 'row',
        width: '100%',
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        margin: '0px 0px 0px 32px', // top right bottom left
        backgroundColor: Theme.Colours.background,
        color: Theme.Colours.text,
        borderBottom: Theme.Colours.border,
        gap: '32px',
    },
    tabsItem: {
        height: '46px',
        display: 'flex',
        alignItems: 'center',
        margin: '8px 16px 0px 0px',
        padding: '0px 8px 0px 8px', // top right bottom left
        gap: '10px',

        cursor: 'pointer',
        backgroundColor: 'transparent',
        color: Theme.Colours.text,
        transition: 'all 0.3s ease',
    },
    tabsItemSelected: {
        height: '46px',
        display: 'flex',
        alignItems: 'center',
        margin: '8px 16px 0px 0px',
        padding: '0px 8px 0px 8px', // top right bottom left
        gap: '10px',

        cursor: 'pointer',
        color: Theme.Colours.text,
        transition: 'all 0.3s ease',

        fontWeight: '500',
        borderBottom: `3px solid ${Theme.Colours.buttonBackground}`,
    },
};
